var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"add btn btn-primary",staticStyle:{"flex":"1","min-width":"200px"},attrs:{"type":"button"},on:{"click":_vm.sendAddToCart}},[_c('span',[_vm._v("加入購物車")])])}
var staticRenderFns = []

export { render, staticRenderFns }